<template>
  <v-flex>
    <v-dialog max-width="400"
      v-model="rangeDialog">
      <v-card>
        <v-date-picker v-model="rangePicker"
          @change="handleRangePickerChange"
          full-width
          range></v-date-picker>
      </v-card>
    </v-dialog>
    <v-select class="caption mt-0"
      hide-details
      dense
      @input="handleSelectClick"
      v-model="range_value"
      :items="rangeItems"></v-select>
  </v-flex>
</template>
<script>
export default {
  data() {
    return {
      rangePicker: [],
      rangeDialog: false,
      range_value: "7days",
      rangeItems: [
        {
          text: "近七天",
          value: "7days"
        },
        {
          text: "本月份",
          value: "thismonth"
        },
        {
          text: "近30天",
          value: "30days"
        },
        {
          text: "近90天",
          value: "90days"
        },
        {
          text: "自訂",
          value: "custom"
        }
      ]
    };
  },
  methods: {
    handleRangePickerChange($event) {
      if ($event.length == 2) {
        let date_range = {
          start: null,
          end: null
        };
        if (this.$moment($event[0]).isAfter($event[1])) {
          date_range.start = $event[1];
          date_range.end = $event[0];
        } else {
          date_range.start = $event[0];
          date_range.end = $event[1];
        }
        this.range_value = "custom";
        this.$emit("input", date_range);
        setTimeout(() => {
          this.rangeDialog = false;
        }, 0);
      }
    },
    customOpen() {
      this.rangeDialog = true;
    },
    handleSelectClick($event) {
      if ($event == "custom") {
        this.customOpen();
      }
    },
    handleRangeValueChange(new_value, old_value) {
      if (this.range_value == "custom") {
        if (!this.rangeDialog) {
          this.customOpen();
          setTimeout(() => {
            this.range_value = old_value;
          }, 0);
        }
        return;
      } else {
        let date_range = {
          start: null,
          end: null
        };
        date_range.end = this.$moment().format("YYYY-MM-DD");
        let start_date;
        if (this.range_value == "7days") {
          start_date = this.$moment().add(-6, "days");
        } else if (this.range_value == "thismonth") {
          start_date = this.$moment().startOf("month");
        } else if (this.range_value == "30days") {
          start_date = this.$moment().add(-29, "days");
        } else if (this.range_value == "90days") {
          start_date = this.$moment().add(-89, "days");
        }
        date_range.start = start_date.format("YYYY-MM-DD");
        this.$emit("input", date_range);
      }
    }
  },
  mounted() {
		if(this.timeMode){
			this.range_value = this.timeMode
		}
    this.handleRangeValueChange();
  },
  watch: {
    range_value: {
      handler(new_value, old_value) {
        this.handleRangeValueChange(new_value, old_value);
      }
    }
  },
  props: {
    timeMode: {
      type: String,
      default: null
    }
  }
};
</script>